module.exports = __webpack_public_path__ + "static/media/toggle.7cc0e3af.png";